import { render, staticRenderFns } from "./beauty-profile.vue?vue&type=template&id=75d66a6e&"
import script from "./beauty-profile.vue?vue&type=script&lang=js&"
export * from "./beauty-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports